import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { RxMethods } from './../../services/rxjs.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-auto-complete',
  templateUrl: './auto-complete.component.html',
  styleUrls: ['./auto-complete.component.css']
})
export class AutoCompleteComponent implements OnInit, OnDestroy {

  constructor(private rxMethods: RxMethods) { }

  @Input() datasource: any[];
  @Input() configs: any;
  @Input() formGroup?: FormGroup;
  onItemChanged = this.rxMethods.createSubjectService();
  onValueChanged = this.rxMethods.createSubjectService();
  filterdData: SelectItem[];
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  selectedItem: any;

  onSuggestionSelected(item: any) {
    if (this.configs.onSuggestionSelected) {
      this.configs.onSuggestionSelected(item, this.configs.scope, this.configs.id, this);
    }
    this.selectedItem = item ? item : { id: null, value: null };
    if (item) {
      this.onItemChanged.next(item);
    }
  }

  filterDropDown(event) {
    this.filterdData = [];
    for (let i = 0; i < this.datasource.length; i++) {
      const item = this.datasource[i];
      const enteredText = event.query ? event.query.toLowerCase() : '';
      const valueField = item[this.configs['displayField']].toLowerCase();
      // User includes instead of indexOf to search in contains method
      if ((valueField) && (enteredText === '' || valueField.indexOf(enteredText) > -1)) {
        this.filterdData.push(item);
      } else if (enteredText === '' || item[this.configs['displayField']].indexOf(enteredText) > -1) {
        this.filterdData.push(item);
      }
    }
  }

  onScrollToEnd() {
    this.fetchMore();
  }

  onScroll({ end }) {
    if (this.loading || this.datasource.length === this.filterdData.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.filterdData.length) {
      this.fetchMore();
    }
  }

  private fetchMore() {
    const len = this.filterdData.length;
    const more = this.datasource.slice(len, this.configs.bufferSize + len);
    this.loading = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading = false;
      this.filterdData = this.filterdData.concat(more);
    }, 200);
  }

  onClearText(event) {
    this.onValueChanged.next(this.selectedItem);
  }

  ngOnInit() {
    const bufferSize = this.configs ? this.configs.bufferSize : 0;
    this.filterdData = this.datasource ? this.datasource.slice(0, bufferSize ? bufferSize : 10) : [];
    const selectedValue = this.datasource.find((elem) => elem.select === true);

    if (selectedValue) {
      this.formGroup.controls[this.configs['id']].patchValue(selectedValue);
    } else if (this.configs && this.configs.displayField && this.configs.defaultValue) {
      this.formGroup.controls[this.configs['id']].patchValue(this.configs.defaultValue);
    }


    this.configs['compScope'] = this;
  }

  ngOnDestroy(): void {
    this.onItemChanged.unsubscribe();
    this.onValueChanged.unsubscribe();
  }
}





